
import {
  email,
  required,
  minLength
} from "vuelidate/lib/validators";
import errorParseNetwork from "~/helpers/errorParseNetwork";
import {getAdditionalData, parseUtmLabels} from "~/helpers/formSend";
import transliterate from "~/helpers/transliterate";

export default {
  name: "BackCall",

  data: function () {
    return {
      form: {
        name: "",
        phone: ""
      },

      activeTab: "mini"
    }
  },

  validations: function () {
    const form = {
      name: {
        required,
      },
      phone: {
        required,
        minLength: minLength(18)
      },
    };

    return {
      form,
    };
  },

  computed: {
    isOpen: function () {
      if (this.$store?.state?.appState?.vars?.['Отключить форму обратной связи'] === '1') {
        return false
      }
      return this.$store.state["back-call"].isOpen || false
    },
    isHideTabs: function () {
      return this.options?.hideTabs || false
    },
    isHideMessage: function () {
      return Boolean(this.options?.hideMessage)
    },
    isEnableSuccessPopUp: function () {
      return Boolean((this.$store.state.appState?.vars?.['Включить POP UP успешной отправки формы'] || '0') === '1')
    },

    options: function () {
      return this.$store.state["back-call"]?.settings || {}
    },

    title: function () {
      return this.options?.title || "Обратный звонок"
    },
    message: function () {
      if (this.isHideMessage) {
        return
      }
      const cmsMessage = this.$store.state.appState?.vars?.['Обратный звонок (сообщение)'] || "";
      return cmsMessage
    },

    type: function () {
      return this.options?.type || ""
    },

    isUseRecaptcha: function () {
      return Boolean(this.$store.state.appState?.config?.useReCaptchaForForms)
    },

    customNotification: function () {
      return this.options?.customNotification || ''
    },
  },

  components: {
    FormBig: () => import("./back-call/FormBig"),
    FormMini: () => import("./back-call/FormMini"),
  },

  watch: {
    isOpen: function () {
      if (this.isOpen) {
        this.initForm();
        this.setPopUpUrl();
      } else {
        this.removePopUpUrl();
      }
    }
  },

  methods: {
    setPopUpUrl: function () {
      const _popUpKey = ([this.title, this.type].filter((t) => !!t).join("_").toLowerCase() || "").replaceAll(" ", "");
      const popUpKey = transliterate(_popUpKey);
      const currentUrl = new URL(window.location.href);
      let currentSearch = new URLSearchParams(currentUrl.search);
      currentSearch.delete('pop-up-form');
      currentSearch.set('pop-up-form', popUpKey);
      currentSearch = currentSearch.toString();
      const clearHref = (window.location.href || "").split("?")?.[0] || "";
      const reloadUrl = [clearHref, currentSearch].filter((t) => !!t).join("?");
      window.history.replaceState(null, null, reloadUrl);
    },
    removePopUpUrl: function () {
      const currentUrl = new URL(window.location.href);
      let currentSearch = new URLSearchParams(currentUrl.search);
      currentSearch.delete('pop-up-form');
      currentSearch = currentSearch.toString();
      const clearHref = (window.location.href || "").split("?")?.[0] || "";
      const reloadUrl = [clearHref, currentSearch].filter((t) => !!t).join("?");
      window.history.replaceState(null, null, reloadUrl);
    },

    initForm: function () {
      if (this.options?.activeTab) {
        this.activeTab = this.options?.activeTab;
      }
    },

    close: function () {
      this.activeTab = "mini";
      this.$store.commit("back-call/setOpen", false);
    },
    changeTab: function (activeTab) {
      this.activeTab = activeTab;

      if (this.$refs.refFormMini) {
        this.$refs.refFormMini.resetForm();
      }
      if (this.$refs.refFormBig) {
        this.$refs.refFormBig.resetForm();
      }
    },

    submitForm: async function (body, codeRecaptcha = '') {
      if (this.isUseRecaptcha && !codeRecaptcha) {
        this.$store.commit("recaptcha/onOpen", {
          onSubmit: this.submitForm.bind(this, body)
        })
        return
      }
      if (this.isUseRecaptcha && codeRecaptcha) {
        body['g-recaptcha-response'] = codeRecaptcha;
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: true });

      const utmLabels = parseUtmLabels();
      if (utmLabels) {
        body.additional_data = {
          ...(body.additional_data || {}),
          ...utmLabels
        }
      }

      if (this.options?.message) {
        body.message = [body.message, this.options?.message]
            .filter((t) => !!t)
            .join("; ");
      }
      body.source = this.$cookies.get('sbjs_current') || '';

      if (!!this.type) {
        body.type = this.type;
      }

      body.additional_data = await getAdditionalData({...body.additional_data}, {
        $yandexMetrika: this.$yandexMetrika
      });

      const response = await this.$api.agent.transport.post("/form/send", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {
          error: errorParseNetwork(err.response)
        }
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });

        this.$toast.error(response.error);

        return
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
      this.$toast.success("Заявка успешно отправлена");

      let reachGoal = this.options?.miniReachGoal || "leave_request_callback_header";
      if (this.$refs.refFormBig) {
        reachGoal = this.options?.fullReachGoal || "leave_reques_polugut_racget_header";
      }
      this.$yandexMetrika.reachGoal(reachGoal);
      this.$yaglaaction(reachGoal);

      const _customNotification = String(this.customNotification || '');

      this.close();

      if (this.isEnableSuccessPopUp) {
        if (!_customNotification) {
          this.$store.commit("back-call-custom/setOpen", true);
        }
        if (_customNotification && _customNotification.length > 1) {
          this.$store.commit("back-call-custom/setOpen", {
            open: true,
            settings: {
              message: String(_customNotification),
            }
          })
        }
      }

      if (this.$refs.refFormMini) {
        this.$refs.refFormMini.resetForm();
      }
      if (this.$refs.refFormBig) {
        this.$refs.refFormBig.resetForm();
      }
    }
  }
}
